import React from 'react';
import { Box, Typography, Chip, Fade } from '@mui/material';
import { DocumentScanner, PictureAsPdf, Description } from '@mui/icons-material';

interface DocumentProcessingSectionProps {
  showDocumentProcessing: boolean;
  documentProcessingText: string;
  currentProcessingPhase?: string;
}

export const DocumentProcessingSection: React.FC<DocumentProcessingSectionProps> = ({ 
  showDocumentProcessing, 
  documentProcessingText,
  currentProcessingPhase
}) => {
  if (!showDocumentProcessing || !documentProcessingText) return null;

  // Choose icon based on processing text content
  const getProcessingIcon = () => {
    if (documentProcessingText.toLowerCase().includes('pdf')) {
      return <PictureAsPdf sx={{ color: '#dc2626', fontSize: '1.25rem' }} />;
    } else if (documentProcessingText.toLowerCase().includes('docx') || documentProcessingText.toLowerCase().includes('word')) {
      return <Description sx={{ color: '#2563eb', fontSize: '1.25rem' }} />;
    }
    return <DocumentScanner sx={{ color: '#059669', fontSize: '1.25rem' }} />;
  };

  return (
    <Fade in={showDocumentProcessing} timeout={500}>
      <Box sx={{
        mt: 2,
        p: 2,
        bgcolor: '#f8fafc',
        borderRadius: 2,
        border: '1px solid #e2e8f0',
        boxShadow: '0 2px 6px rgba(15, 23, 42, 0.04)'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
          {getProcessingIcon()}
          <Typography
            variant="subtitle2"
            sx={{
              color: '#1f2937',
              fontWeight: 600,
              fontSize: '0.875rem'
            }}
          >
            Document Processing
          </Typography>
          <Chip
            label="Live"
            size="small"
            sx={{
              backgroundColor: '#dcfce7',
              color: '#166534',
              fontWeight: 600,
              fontSize: '0.65rem',
              height: 18,
              border: '1px solid #bbf7d0'
            }}
          />
          {currentProcessingPhase && (
            <Chip
              label={currentProcessingPhase}
              size="small"
              variant="outlined"
              sx={{
                color: '#475569',
                borderColor: '#cbd5e1',
                fontSize: '0.65rem',
                height: 18
              }}
            />
          )}
        </Box>
        <Typography 
          variant="body2" 
          sx={{
            color: '#334155',
            fontSize: '0.8rem',
            lineHeight: 1.5,
            backgroundColor: '#f1f5f9',
            p: 1.5,
            borderRadius: 1.5,
            border: '1px solid #e2e8f0'
          }}
        >
          {documentProcessingText}
        </Typography>
      </Box>
    </Fade>
  );
}; 